import type { IconData } from '@stacksjs/iconify-core'

export const fingerprint2: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 20v8m-9-7.25q0-.267.002-.533c.03-5.062 3.925-9.217 8.987-9.217c5.068 0 8.889 4.15 8.978 9.216a214 214 0 0 1 0 7.568C32.877 32.851 29.057 37 23.99 37c-5.073 0-8.961-4.144-8.988-9.217L15 27.25\"/><path d=\"M33.5 5.708A17.9 17.9 0 0 0 24 3C14.059 3 6 11.059 6 21v6c0 8.743 6.234 16.031 14.5 17.66M38.622 10.5A17.9 17.9 0 0 1 42 21v6c0 8.743-6.234 16.031-14.5 17.66\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default fingerprint2
